import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import "./ExpoAgr.scss";
import { connect } from "react-redux";
import { customerService } from "../../services";

const HOME_ICON = {
    1: "/images/expo/M1.png",
    2: "/images/expo/M2.png",
    3: "/images/expo/M3.png",
    4: "/images/expo/M4.png",
    5: "/images/expo/M5.png",
};

const MISSION_META = {
    1: { no: 1, code: "MISSION 1", icon: HOME_ICON[1], title: "SOIL EXPERT" },
    2: { no: 2, code: "MISSION 2", icon: HOME_ICON[2], title: "บูทสาธิตประสิทธิภาพ\nแอ็ปซ่า-80", textClass: "mCardText2" },
    3: { no: 3, code: "MISSION 3", icon: HOME_ICON[3], title: "พืชสวน" },
    4: { no: 4, code: "MISSION 4", icon: HOME_ICON[4], title: "พืชไร่" },
    5: { no: 5, code: "MISSION 5", icon: HOME_ICON[5], title: "เวที Mini stage" },
};

const ASSET = {
    home: "/images/expo/M0.png",
    pass: "/images/expo/mission-pass.png",
    passBlack: "/images/expo/mission-pass-black.png",
    question: "/images/expo/mission-question-intro.png",
    loading: "/images/expo/loading_white.gif",
};

const DEFAULT_QUESTIONS = [
    { id: "q1", correctId: "a" },
    { id: "q2", correctId: "b" },
    { id: "q3", correctId: "a" },
];

const QUESTION_UI = [
    {
        id: "q1",
        title: "คำถามข้อที่ 1",
        desc: "ผลิตภัณฑ์ใดในกลุ่มผลิตภัณฑ์เพื่อการเกษตรที่สามารถใช้ได้ทั้งทางดิน และทางใบ",
        options: [
            { id: "a", label: "A . APSA-80", img: "/images/expo/q1-a.png" },
            { id: "b", label: "B . นิวทริแพลนท์ ซอยล์ พลัส", img: "/images/expo/q1-b.png" },
        ],
    },
    {
        id: "q2",
        title: "คำถามข้อที่ 2",
        desc: "หากพืชอยู่ในสภาวะเครียดต้องใช้ผลิตภัณฑ์ใดเพื่อลดปัญหา",
        options: [
            { id: "a", label: "A . APSA-80", img: "/images/expo/q2-a.png" },
            { id: "b", label: "B . นิวทริแพลนท์ เอจี พลัส", img: "/images/expo/q2-b.png" },
        ],
    },
    {
        id: "q3",
        title: "คำถามข้อที่ 3",
        desc: "ผลิตภัณฑ์ใดที่ช่วยเรื่องการปรับโครงสร้างดิน กระตุ้นการทำงานของจุลินทรีย์ที่มีประโยชน์",
        options: [
            { id: "a", label: "A . นิวทริแพลนท์ ซอยล์ พลัส", img: "/images/expo/q3-a.png" },
            { id: "b", label: "B . นิวทริแพลนท์ เอจี พลัส", img: "/images/expo/q3-b.png" },
        ],
    },
];

// util: preload
const preloadImages = (urls = []) =>
    Promise.all(
        urls
            .filter(Boolean)
            .map(
                (src) =>
                    new Promise((resolve) => {
                        const img = new Image();
                        img.onload = resolve;
                        img.onerror = resolve;
                        img.src = src;
                    })
            )
    );

function ExpoAgr({ profile }) {
    const customerLS = useMemo(() => {
        try {
            const raw = localStorage.getItem("customer");
            return raw ? JSON.parse(raw) : null;
        } catch {
            return null;
        }
    }, []);

    const [screen, setScreen] = useState("home");
    const [passedMissionSet, setPassedMissionSet] = useState(new Set());
    const [currentMission, setCurrentMission] = useState(null);
    const [selectedMission, setSelectedMission] = useState(null);

    const [amwayNumber, setAmwayNumber] = useState(null);
    const [partyId, setPartyId] = useState(null);

    const [passDigits, setPassDigits] = useState(["", "", "", ""]);
    const [missionPasswords, setMissionPasswords] = useState({ 1: [], 2: [], 3: [], 4: [], 5: [] });
    const [isCheckingPass, setIsCheckingPass] = useState(false);

    const [questions] = useState(DEFAULT_QUESTIONS);
    const [answers, setAnswers] = useState({});
    const [allCorrect, setAllCorrect] = useState(false);
    const [checked, setChecked] = useState(false);

    const passRefs = useRef([]);

    const [bgReady, setBgReady] = useState(false);

    const passCode = useMemo(() => passDigits.join(""), [passDigits]);
    const passComplete = useMemo(() => passDigits.every((d) => d !== ""), [passDigits]);
    const answeredAll3 = useMemo(() => questions.every((q) => !!answers[q.id]), [answers, questions]);
    const [pageReady, setPageReady] = useState(false);
    const [staffReady, setStaffReady] = useState(false);
    const [customerReady, setCustomerReady] = useState(false);
    const [passedReady, setPassedReady] = useState(false);
    const [passedFetched, setPassedFetched] = useState(false);
    const dataReady = staffReady && customerReady && passedReady;
    useEffect(() => {
        let cancelled = false;

        const run = async () => {
            await new Promise((r) => requestAnimationFrame(() => requestAnimationFrame(r)));
            try {
                if (document.fonts?.ready) await document.fonts.ready;
            } catch { }

            if (!cancelled) setPageReady(true);
        };

        run();
        return () => { cancelled = true; };
    }, []);
    const resetPass = () => setPassDigits(["", "", "", ""]);

    // bg per screen
    const bgSrc = useMemo(() => {
        const map = {
            home: ASSET.home,
            pass: ASSET.pass,
            passBlack: ASSET.passBlack,
            question: ASSET.question,
        };

        return map[screen] || ASSET.home;
    }, [screen]);

    // preload ทั้งชุด (ครั้งเดียว)
    useEffect(() => {
        const urls = [
            ...Object.values(ASSET),
            ...Object.values(HOME_ICON),
            ...QUESTION_UI.flatMap((q) => q.options.map((o) => o.img)),
        ];
        preloadImages(urls);
    }, []);

    // preload เฉพาะ bgSrc ที่กำลังจะโชว์ เพื่อเปิด bgReady
    useEffect(() => {
        setBgReady(false);
        const img = new Image();
        img.onload = () => setBgReady(true);
        img.onerror = () => setBgReady(true);
        img.src = bgSrc;
    }, [bgSrc]);


    useEffect(() => {
        const el = document.getElementById("wrapper");
        if (!el) return;

        el.classList.add("expo-full");
        return () => el.classList.remove("expo-full");
    }, []);

    useEffect(() => {
        if (!passedFetched) return;
        setPassedReady(true);
    }, [passedFetched]);

    // ===== customer from LS =====
    useEffect(() => {
        if (customerLS?.amwayNumber && !amwayNumber) setAmwayNumber(customerLS.amwayNumber);
        if (customerLS?.partyId && !partyId) setPartyId(customerLS.partyId);
    }, [customerLS, amwayNumber, partyId]);

    // ===== customer log =====
    useEffect(() => {
        let cancelled = false;

        const fetchCustomer = async () => {
            if (profile == null) return;

            if (!profile?.userId) {
                if (!cancelled) setCustomerReady(true);
                return;
            }

            try {
                const c = await customerService.get(profile.userId);
                if (!c?.amwayNumber) return;

                if (!cancelled) {
                    setAmwayNumber(c.amwayNumber);
                    setPartyId(c.partyId);
                }

                const res = await axios.post(`${process.env.REACT_APP_API_URL}/customers/expo`, {
                    uid: c.uid,
                    amwayNumber: c.amwayNumber,
                    partyId: c.partyId,
                    type: "M",
                });

                const logs = Array.isArray(res.data?.customerLog) ? res.data.customerLog : [];

                const hasMAll = logs.some((l) => String(l.type || "").toUpperCase() === "MALL");
                if (hasMAll) {
                    window.location.replace("/expo?type=agr");
                    return;
                }

                const nextSet = new Set();
                logs.forEach((l) => {
                    const t = String(l.type || "").toUpperCase();
                    if (t.startsWith("M")) {
                        const no = Number(t.replace("M", ""));
                        if (!Number.isNaN(no)) nextSet.add(no);
                    }
                });

                if (!cancelled) {
                    setPassedMissionSet(nextSet);
                    setPassedFetched(true);
                }

                if (!staffReady) {
                    try {
                        const staffRes = await axios.post(`${process.env.REACT_APP_API_URL}/customers/expo_staff`, {});
                        const rows = Array.isArray(staffRes.data) ? staffRes.data : [];

                        const temp = { 1: [], 2: [], 3: [], 4: [], 5: [] };
                        rows.forEach((r) => {
                            const type = String(r.type || "").toLowerCase();
                            const clean = String(r.amwayNumber || "").replace(/\D/g, "");
                            if (clean.length !== 4) return;

                            if (type === "m1") temp[1].push(clean);
                            if (type === "m2") temp[2].push(clean);
                            if (type === "m3") temp[3].push(clean);
                            if (type === "m4") temp[4].push(clean);
                            if (type === "m5") temp[5].push(clean);
                        });

                        if (!cancelled) setMissionPasswords(temp);
                    } catch (e) {
                        console.error("fetchStaff error", e);
                    } finally {
                        if (!cancelled) setStaffReady(true);
                    }
                }
            } catch (e) {
                console.error("fetchCustomer error", e);
            } finally {
                if (!cancelled) setCustomerReady(true);
            }
        };

        fetchCustomer();
        return () => { cancelled = true; };
    }, [profile?.userId]);



    const submitPassSuccess = async () => {
        try {
            if (!amwayNumber || !partyId) return;
            await axios.post(`${process.env.REACT_APP_API_URL}/customers/expo_pass`, {
                uid: profile.userId,
                amwayNumber,
                partyId,
                type: `M${currentMission}`,
            });
        } catch (e) {
            console.error("expo_pass error", e);
        }
    };

    // ===== select mission =====
    const onClickMission = (missionNo) => {
        const m = MISSION_META[missionNo];
        setSelectedMission(m);
        setCurrentMission(m.no);
        resetPass();
        setScreen("pass");
    };

    const onPassChange = (idx, raw) => {
        const v = (raw || "").replace(/\D/g, "").slice(-1);
        setPassDigits((prev) => {
            const next = [...prev];
            next[idx] = v;
            return next;
        });
        if (v && idx < 3) setTimeout(() => passRefs.current?.[idx + 1]?.focus?.(), 0);
    };

    const onPassKeyDown = (idx, e) => {
        if (e.key === "Backspace" && !passDigits[idx] && idx > 0) {
            setTimeout(() => passRefs.current?.[idx - 1]?.focus?.(), 0);
        }
    };

    useEffect(() => {
        if (screen !== "pass") return;
        if (!passComplete) return;
        setScreen("passBlack");
    }, [passComplete, screen]);

    const onClickCheckPass = async () => {
        if (!passComplete || isCheckingPass) return;

        setIsCheckingPass(true);

        const expectedList = currentMission ? missionPasswords[currentMission] || [] : [];
        const ok = expectedList.includes(passCode);

        setTimeout(async () => {
            if (!ok) {
                resetPass();
                setScreen("pass");
                setIsCheckingPass(false);
                setTimeout(() => passRefs.current?.[0]?.focus?.(), 50);
                return;
            }

            await submitPassSuccess();

            setPassedMissionSet((prev) => {
                const next = new Set(prev);
                next.add(currentMission);
                return next;
            });

            resetPass();
            setSelectedMission(null);
            setScreen("home");
            setIsCheckingPass(false);
        }, 350);
    };

    const goNextToQuestion = () => {
        setAnswers({});
        setAllCorrect(false);
        setChecked(false);
        setScreen("question");
    };

    // auto check หลังเลือกครบ 3
    useEffect(() => {
        if (!answeredAll3) return;
        const isAllCorrect = questions.every((q) => answers[q.id] === q.correctId);
        setChecked(true);
        setAllCorrect(isAllCorrect);
    }, [answeredAll3, answers, questions]);

    const onSelectChoice = (qId, choiceId) => {
        if (checked) return;
        setAnswers((prev) => ({ ...prev, [qId]: choiceId }));
    };

    const handleSubmitAnswer = async () => {
        if (!answeredAll3) return;
        if (!checked) return;

        if (!allCorrect) {
            setChecked(false);
            setAllCorrect(false);
            setAnswers({});
            return;
        }

        try {
            await axios.post(`${process.env.REACT_APP_API_URL}/customers/expo_pass`, {
                uid: profile.userId,
                amwayNumber,
                partyId,
                type: "MAll",
            });
            window.location.replace("/expo?type=agr");
        } catch (e) {
            console.error("submit MAll error", e);
        }
    };

    const lockCards = passedMissionSet.size === 5;

    return (
        <div className="ExpoAgr">
            <div className={`missionPage screen-${screen}`}>
                {(!pageReady || !bgReady || !dataReady) && <div className="bgLoading" />}

                <img
                    className="missionImg"
                    src={bgSrc}
                    alt="mission"
                    style={{ opacity: pageReady && bgReady && dataReady ? 1 : 0, transition: "opacity .25s ease" }}

                />

                {pageReady && dataReady && (
                    <>
                        {screen === "home" && passedReady && (
                            <div className={`homeOverlay ${!passedReady ? "disabled" : ""}`}>
                                <div className="missionGrid">
                                    {[1, 2, 3, 4].map((no) => {
                                        const m = MISSION_META[no];
                                        return (
                                            <button
                                                key={no}
                                                className={`mCard ${passedMissionSet.has(no) ? "done" : ""}`}
                                                onClick={() => !lockCards && onClickMission(no)}
                                                type="button"
                                                disabled={lockCards}
                                            >
                                                <div className="mCardTop">
                                                    <img className="mIcon" src={m.icon} alt="" />
                                                </div>
                                                <div className="mCardBar">
                                                    {passedMissionSet.has(no) ? "COMPLETE" : m.code}
                                                </div>
                                                <div className={m.textClass || "mCardText1"}>{m.title}</div>
                                            </button>
                                        );
                                    })}
                                </div>

                                <div className="missionBottom">
                                    {(() => {
                                        const m = MISSION_META[5];
                                        return (
                                            <button
                                                className={`mCard mCardSmall ${passedMissionSet.has(5) ? "done" : ""}`}
                                                onClick={() => !lockCards && onClickMission(5)}
                                                type="button"
                                                disabled={lockCards}
                                            >
                                                <div className="mCardTop">
                                                    <img className="mIcon" src={m.icon} alt="" />
                                                </div>
                                                <div className="mCardBar">
                                                    {passedMissionSet.has(5) ? "COMPLETE" : m.code}
                                                </div>
                                                <div className="mCardText1">{m.title}</div>
                                            </button>
                                        );
                                    })()}
                                </div>

                                {passedMissionSet.size === 5 && (
                                    <div className="missionNextWrapper">
                                        <button className="missionNextBtn" onClick={goNextToQuestion}>
                                            NEXT
                                        </button>
                                    </div>
                                )}
                            </div>
                        )}

                        {(screen === "pass" || screen === "passBlack") && selectedMission && (
                            <div className="missionInfoOverlay">
                                <div className="missionInfoCode">{selectedMission.code}</div>
                                <img
                                    className="missionInfoIcon"
                                    src={selectedMission.icon}
                                    alt={selectedMission.code}
                                />
                                <div className="missionInfoTitle">{selectedMission.title}</div>
                            </div>
                        )}

                        {(screen === "pass" || screen === "passBlack") && (
                            <div className="expocodeAgrPanel">
                                <div className="expocodeAgrRow">
                                    {passDigits.map((v, idx) => (
                                        <input
                                            key={idx}
                                            ref={(el) => (passRefs.current[idx] = el)}
                                            className="expocAgrodeInput"
                                            inputMode="numeric"
                                            value={v}
                                            onChange={(e) => onPassChange(idx, e.target.value)}
                                            onKeyDown={(e) => onPassKeyDown(idx, e)}
                                            maxLength={1}
                                            type="password"
                                        />
                                    ))}
                                </div>
                            </div>
                        )}

                        {screen === "passBlack" && (
                            <div
                                className={`expoAgrenterHit ${passComplete && !isCheckingPass ? "enabled" : "disabled"
                                    }`}
                                onClick={onClickCheckPass}
                                role="button"
                            />
                        )}

                        {screen === "question" && (
                            <div className="questionOverlay" onClick={(e) => e.stopPropagation()}>
                                <div className="questionCard">
                                    {QUESTION_UI.map((q) => (
                                        <div key={q.id} className="qBlock">
                                            <div className="qTitle">{q.title}</div>
                                            <div className="qDesc">{q.desc}</div>

                                            <div className="qOptions">
                                                {q.options.map((op) => {
                                                    const selected = answers[q.id] === op.id;
                                                    return (
                                                        <button
                                                            key={op.id}
                                                            type="button"
                                                            disabled={checked}
                                                            className={`qOpt
                                    ${selected ? "selected" : ""}
                                    ${checked &&
                                                                    allCorrect &&
                                                                    answers[q.id] === q.correctId
                                                                    ? "correct"
                                                                    : ""
                                                                }
                                    ${checked &&
                                                                    !allCorrect &&
                                                                    selected &&
                                                                    answers[q.id] !== q.correctId
                                                                    ? "wrong"
                                                                    : ""
                                                                }
                                  `}
                                                            onClick={() => onSelectChoice(q.id, op.id)}
                                                        >
                                                            <img className="qOptImg" src={op.img} alt={op.label} />
                                                            <div className="qOptLabel">{op.label}</div>
                                                        </button>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <button
                                    type="button"
                                    className={`
                        selectAnswerBtn
                        ${answeredAll3 ? "enabled" : "disabled"}
                        ${checked && !allCorrect ? "wrong" : ""}
                        ${checked && allCorrect ? "correct" : ""}
                      `}
                                    disabled={!answeredAll3}
                                    onClick={handleSubmitAnswer}
                                >
                                    {!checked && "SELECT ANSWER"}
                                    {checked && !allCorrect && "WRONG ANSWER"}
                                    {checked && allCorrect && "SUBMIT"}
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );

}

export default connect((s) => ({ profile: s.profile }))(ExpoAgr);
